// Спека 02 §A2 — пиксели макета, не подходящие ни под один токен сетки.
export const MASCOT_SIZE = 262
export const TITLE_COLUMN_WIDTH = 196
/**
 * 196, а не 150 из текста спеки: маскот 262px с `top:-14` заканчивается на 248px, и при
 * 150 подзаголовок уезжал прямо под собаку. В макете (`Экраны - онбординг.dc.html#a2`)
 * колонка заголовка тоже 196 — берём макет.
 */
export const TITLE_COLUMN_HEIGHT = 196

/** Заглушка «Луня дружит с теми, кто постарше» — маскот 150px (доработки §d9). */
export const AGE_GATE_MASCOT_SIZE = 150

/**
 * На какой дате открыть барабаны, если дата рождения ещё не выбрана.
 * Сегодняшнее число тут бессмысленно: аудитория продукта — 18–35, а пустой пикер,
 * открытый на сегодня, сразу упирается в возрастную заглушку.
 */
export const BIRTH_DATE_PICKER_DEFAULT = new Date(2000, 0, 1)
